
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../controlador';
    import * as Pedidos from '@/__env/lib/Ventas/Pedidos';
    import _ from 'lodash';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Wait } from '@/__env/ext';
    import { Guid } from 'guid-typescript';
    import { UsuarioActual } from '@/views/a-login/login-controlador';

    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorInterfaz;
        public get Pedido() { return this.Controlador.Pedido; }
        public get Estado() { return this.Controlador.Vista.Estado; }

        public Cargando: boolean = false;
        public Abrir: boolean = false;
        public Guid: string = '';
        public get Ok(): boolean
        {
            return true;
        }

        public async Ejecutar()
        {
            if ( UsuarioActual.Grupo != 'administrador' )
            {
                await Utiles.Mensajes.Aceptar( 'Error', 'No estás habilitado a descargar el pedido.' );
                return;
            }
            this.Guid = Guid.create().toString();
            window.location = `facturar:solo_descargar=S;pedido=${this.Pedido.Id};ope=${this.Guid};token=R4D8S4d-aw5f1h8f6-d4a8s5w8d6x`;
        }


    }
